package com.exura.features.plandefinition.di

import com.exura.features.firebase.data.serialization.versionSerializersModule
import com.exura.features.plandefinition.data.mappers.plandefinition.CollectionMappers
import com.exura.features.plandefinition.data.mappers.plandefinition.PolymorphicElementMappers
import com.exura.features.plandefinition.data.mappers.plandefinition.PolymorphicPlanMappers
import com.exura.features.plandefinition.data.mappers.plandefinition.PolymorphicSeriesMappers
import com.exura.features.plandefinition.data.repository.*
import com.exura.features.plandefinition.data.serialization.collectionSerializersModule
import com.exura.features.plandefinition.data.serialization.elementSerializersModule
import com.exura.features.plandefinition.data.serialization.planSerializersModule
import com.exura.features.plandefinition.data.serialization.seriesSerializersModule
import com.exura.features.plandefinition.domain.repository.*
import com.exura.features.plandefinition.usecase.*
import org.koin.dsl.module

val providerPlanDefinitionModule = module {

    single<BasePlanRepository> {
        BasePlanRepositoryImpl(
            firestore = get(),
            dtoSerializersModule = planSerializersModule,
            mapper = PolymorphicPlanMappers()
        )
    }

    single<PlanSeriesRepository> {
        PlanSeriesRepositoryImpl(
            firestore = get(),
            dtoSerializersModule = seriesSerializersModule,
            mapper = PolymorphicSeriesMappers(),
        )
    }

    single<PlanElementsRepository> {
        PlanElementsRepositoryImpl(
            firestore = get(),
            dtoSerializersModule = elementSerializersModule,
            mapper = PolymorphicElementMappers(),
        )
    }

    single<PlanCollectionRepository> {
        PlanCollectionRepositoryImpl(
            firestore = get(),
            dtoSerializersModule = collectionSerializersModule,
            mapper = CollectionMappers(),
        )
    }

    single<PlanDefinitionRepository> {
        PlanDefinitionRepositoryImpl(
            planRepository = get(),
            collectionRepository = get(),
            seriesRepository = get(),
            elementsRepository = get(),
        )
    }

    single<PlanVersionRepository> {
        PlanVersionRepositoryImpl(
            firestore = get(),
            dtoSerializersModule = versionSerializersModule,
        )
    }

    single<VersionedPlanDefinitionRepository> {
        PlanDefinitionVersioned(
            itemRepository = get<PlanDefinitionRepository>(),
            versionsRepository = get<PlanVersionRepository>(),
            getUserDataPrefixUseCase = get(),
        )
    }

    single<ProviderPlanDefinitionRepository> {
        ProviderPlanDefinitionRepositoryImpl(
            planRepository = get(),
            getUserDataPrefixUseCase = get()
        )
    }

    single<ProviderVersionedTreatmentRepository> {
        ProviderVersionedTreatmentRepositoryImpl(
            planRepository = get(),
            getUserDataPrefixUseCase = get(),
        )
    }

    factory<CreateTreatmentPlanUseCase> { CreateTreatmentPlanUseCase(get()) }
    factory<DeleteTreatmentPlanUseCase> { DeleteTreatmentPlanUseCase(get()) }
    factory<GetTreatmentPlanUseCase> { GetTreatmentPlanUseCase(get()) }
    factory<ListTreatmentPlansUseCase> { ListTreatmentPlansUseCase(get()) }
    factory<UpdateTreatmentPlanUseCase> { UpdateTreatmentPlanUseCase(get()) }

    factory<CreateUnversionedPlanDefinitionUseCase> { CreateUnversionedPlanDefinitionUseCase(get()) }
    factory<GetUnversionedPlanDefinitionUseCase> { GetUnversionedPlanDefinitionUseCase(get()) }
    factory<GetVersionContentUseCase> { GetVersionContentUseCase(get()) }
}
